(function(){
'use strict';
function euro(n){return n.toFixed(2).replace('.',',')+' €';}
function zahl(n){var r=Math.round(n*100)/100;return String(r).replace('.',',');}
function menge(size){return String(size.label).split('·')[0].trim();}
function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}

/* ---------------------------------------------------------------
   GA4-Tracking (V4, 10.09.2026). Jeder Schritt geht als Custom Event
   'rr_step' an Shopifys Analytics-Bus. Das Custom Pixel "GA4 Rasenrechner"
   (Einstellungen > Kundenereignisse) hoert darauf und schickt es als
   Ereignis 'rasenrechner' an GA4 (G-4W3EB0W5JF). Ohne Pixel, ohne
   Zustimmung oder im Theme-Editor passiert nichts. Alle Parameter mit
   Praefix rr_, Strings auf 100 Zeichen gekuerzt (GA4-Limit).
   --------------------------------------------------------------- */
var RR_T0=Date.now();
function track(step,data){
  try{
    if(!window.Shopify||!Shopify.analytics||typeof Shopify.analytics.publish!=='function') return;
    if(Shopify.designMode) return;
    var d={rr_step:step, rr_sekunden:Math.round((Date.now()-RR_T0)/1000)}, k;
    if(data){ for(k in data){ if(data[k]!==undefined&&data[k]!==null&&data[k]!=='') d[k]=data[k]; } }
    for(k in d){ if(typeof d[k]==='string'&&d[k].length>100) d[k]=d[k].slice(0,100); }
    Shopify.analytics.publish('rr_step',d);
  }catch(e){}
}
function flaecheKlasse(q){ return q<=100?'bis 100':(q<=300?'101 bis 300':(q<=600?'301 bis 600':'ueber 600')); }
function produktText(k,name){ return name+' '+zusammen(k); }

/* Preise. Wenn die Sektion window.BLRR_PREISE mitgibt, gelten die Live-Werte aus
   Shopify. Sonst faellt es auf die im Katalog hinterlegten Preise zurueck. */
function preis(size){
  var m = window.BLRR_PREISE && window.BLRR_PREISE[size.id];
  return (m && m.p) ? m.p : size.price;
}
/* Vergleichspreis nur, wenn er echt hoeher ist als der Verkaufspreis. */
function vergleich(size){
  var m = window.BLRR_PREISE && window.BLRR_PREISE[size.id];
  if(!m || !m.c) return 0;
  return (m.c - preis(size) > 0.005) ? m.c : 0;
}

/* ---------------------------------------------------------------
   Gebindekombination: guenstigste Kombination, die den Bedarf in m2
   mindestens abdeckt. Unbounded Knapsack ueber die Deckung.
   Preise kommen ueber preis(), es zaehlen also die Live-Preise.
   --------------------------------------------------------------- */
function kombi(sizes,bedarf){
  if(!(bedarf>0) || !sizes || !sizes.length) return [];
  var n=Math.ceil(bedarf), i, j, s, d, rest, c;
  var cost=new Array(n+1), pick=new Array(n+1);
  cost[0]=0; pick[0]=null;
  for(i=1;i<=n;i++){
    cost[i]=Infinity; pick[i]=null;
    for(j=sizes.length-1;j>=0;j--){
      s=sizes[j]; d=s.deckung||0;
      if(d<=0) continue;
      rest=i-d; if(rest<0) rest=0;
      c=preis(s)+cost[rest];
      if(c<cost[i]-0.0001){ cost[i]=c; pick[i]=s; }
    }
  }
  var out=[], guard=0; i=n;
  while(i>0 && pick[i] && guard++<600){
    s=pick[i];
    var hit=null;
    for(j=0;j<out.length;j++){ if(out[j].s===s){ hit=out[j]; break; } }
    if(hit) hit.qty++; else out.push({s:s,qty:1});
    i-=(s.deckung||0); if(i<0) i=0;
  }
  out.sort(function(a,b){ return (b.s.deckung||0)-(a.s.deckung||0); });
  return out;
}

function zusammen(k){
  var t=[];
  k.forEach(function(x){ t.push((x.qty>1 ? x.qty+' × ' : '')+menge(x.s)); });
  return t.join(' + ');
}
function kombiPreis(k){ var t=0; k.forEach(function(x){ t+=preis(x.s)*x.qty; }); return t; }
function kombiAlt(k){ var t=0; k.forEach(function(x){ t+=(vergleich(x.s)||preis(x.s))*x.qty; }); return t; }

function preisHtml(k){
  var p=kombiPreis(k), a=kombiAlt(k);
  var alt=(a-p>0.005) ? '<s class="blrr-itemAlt">'+euro(a)+'</s>' : '';
  return alt+euro(p);
}

function cartLines(k){
  var out=[];
  k.forEach(function(x){ out.push({id:x.s.id, qty:x.qty}); });
  return out;
}

/* Warenkorb-Drawer oeffnen. Der Shop nutzt NUR den Drawer, die /cart-Seite ist
   bewusst kein Ziel. Neu in V2: nach dem Oeffnen wird geprueft, ob der Drawer
   wirklich sichtbar wurde. Wenn nicht, wird das Warenkorb-Symbol im Header
   geklickt, das die Drawer-Logik des Themes ausloest. */
function oeffneWarenkorb(){
  document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
  var d=document.querySelector('cart-drawer, #CartDrawer, .drawer--cart, [id*="cart-drawer" i]');
  var icon=document.querySelector('.header__icon--cart, a[href="/cart"]');
  if(d){
    if(typeof d.open==='function'){ try{ d.open(); }catch(e){} }
    else{ d.classList.add('active','is-open','open'); }
    setTimeout(function(){
      var r=d.getBoundingClientRect(), st=window.getComputedStyle(d);
      var sichtbar = r.width>0 && r.height>0 && st.visibility!=='hidden' && st.display!=='none';
      if(!sichtbar && icon) icon.click();
    },300);
    return true;
  }
  if(icon){ icon.click(); return true; }
  return false;
}

/* Notnagel: klassisches Formular, falls fetch scheitert. */
function formularFallback(list,props){
  var f=document.createElement('form'); f.method='post'; f.action='/cart/add'; f.style.display='none';
  list.forEach(function(it,i){
    ['id','quantity'].forEach(function(k){var inp=document.createElement('input');inp.type='hidden';inp.name='items['+i+']['+k+']';inp.value=(k==='id'?it.id:it.qty);f.appendChild(inp);});
    Object.keys(props).forEach(function(k){
      var pr=document.createElement('input');pr.type='hidden';
      pr.name='items['+i+'][properties]['+k+']';pr.value=props[k];f.appendChild(pr);
    });
  });
  document.body.appendChild(f); f.submit();
}

/* onDone(status) meldet 'ok' oder 'fallback' ans Tracking (V4). */
function addToCart(list,btn,ladeText,props,onDone){
  if(!list||!list.length)return;
  props = props || {_quelle:'rasenrechner'};
  var alt=btn?btn.textContent:'';
  if(btn){btn.disabled=true; btn.textContent=ladeText||'Wird hinzugefügt …';}
  var items=list.map(function(it){
    return {id:Number(it.id),quantity:it.qty||1,properties:props};
  });
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:items})
  })
  .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
  .then(function(){
    /* Sichtbares Feedback direkt am Knopf, unabhaengig davon, ob der Drawer
       aufgeht. Der Kunde soll nie raten muessen, ob etwas passiert ist. */
    if(btn){
      btn.disabled=false; btn.textContent='✓ Im Warenkorb';
      setTimeout(function(){ btn.textContent=alt; },2400);
    }
    if(typeof onDone==='function'){ try{ onDone('ok'); }catch(e){} }
    oeffneWarenkorb();
  })
  .catch(function(){
    if(typeof onDone==='function'){ try{ onDone('fallback'); }catch(e){} }
    formularFallback(list,props);
  });
}

window.BLRR=function(root,C){
  var qm=200, zustand=null, prefs={schnell:false,langzeit:false,einfach:false,hilfe:false}, step=1;
  var eingabe={slider:false,tippen:false};
  var $=function(s){return root.querySelector(s);};
  var $$=function(s){return Array.prototype.slice.call(root.querySelectorAll(s));};
  function set(sel,prop,val){var el=$(sel); if(el)el[prop]=val;}

  /* Saison. Kommt aus der Sektion (URL-Parameter ?saison=...), Standard herbst.
     Die Saison entscheidet, welches Duenger-Trio empfohlen wird. Nachsaat,
     Erde und Handstreuer sind saisonunabhaengig. */
  var saison=(C.saison==='sommer')?'sommer':'herbst';
  if(C.saisonProdukte && C.saisonProdukte[saison]){
    C.produkte.fluessig=C.saisonProdukte[saison].fluessig;
    C.produkte.kristall=C.saisonProdukte[saison].kristall;
    C.produkte.duo=C.saisonProdukte[saison].duo;
  }

  var S=(C.saetze||{});
  var LADE=(C.texte&&C.texte.laedt)||'Wird hinzugefügt …';
  function T(key,vars){
    var t=S[key]; if(!t) return '';
    return t.replace(/\{(\w+)\}/g,function(m,k){return vars[k]!==undefined?vars[k]:'';});
  }

  function bedarfHtml(prod,bedarf,zielHtml){
    if(prod.rate) return 'Du brauchst <strong>'+zahl(bedarf*prod.rate)+' '+prod.einheit+'</strong> '+zielHtml;
    return 'Passend '+zielHtml;
  }

  /* Hilfen fuers Tracking (V4) */
  function duengerKey(){ if(prefs.schnell&&prefs.langzeit) return 'duo'; if(prefs.langzeit) return 'kristall'; return 'fluessig'; }
  function wunschText(){
    var w=[];
    if(prefs.schnell)  w.push('schnell');
    if(prefs.langzeit) w.push('langzeit');
    if(prefs.einfach)  w.push('einfach');
    if(prefs.hilfe)    w.push('hilfe');
    return w.length ? w.join('+') : 'keine';
  }
  function eingabeArt(){
    if(eingabe.slider&&eingabe.tippen) return 'beides';
    if(eingabe.slider) return 'slider';
    if(eingabe.tippen) return 'tippen';
    return 'standard';
  }
  function zustandKurz(){ var z=C.zustaende[zustand-1]; return z ? z.kurz : 'unbekannt'; }
  function basis(){
    return {rr_saison:saison, rr_flaeche:qm, rr_flaeche_klasse:flaecheKlasse(qm),
            rr_zustand:zustandKurz(), rr_wunsch:wunschText(), rr_duenger:duengerKey()};
  }
  function trackErgebnis(){
    var r=root._r; if(!r) return;
    var namen=[]; r.items.forEach(function(it){ namen.push(produktText(it.k,it.p.name)); });
    var d=basis();
    d.rr_produkte=namen.join('; ');
    d.rr_produkt=r.items[0] ? r.items[0].p.name : '';
    d.rr_anzahl=r.items.length;
    d.rr_luecken_qm=r.lueckenQm;
    d.rr_handstreuer=r.optional.length ? 'ja' : 'nein';
    d.value=Math.round(root._total*100)/100;
    d.rr_spar=Math.round((root._totalAlt-root._total)*100)/100;
    track('ergebnis',d);
  }
  function trackStep(von,nach){
    if(nach<von){ track('zurueck',{rr_saison:saison, rr_von:von, rr_nach:nach}); return; }
    if(von===1) track('flaeche',{rr_saison:saison, rr_flaeche:qm, rr_flaeche_klasse:flaecheKlasse(qm), rr_eingabe:eingabeArt()});
    if(von===2){ var z=C.zustaende[zustand-1]; track('zustand',{rr_saison:saison, rr_zustand:zustandKurz(), rr_boost:(z&&z.boost)?'ja':'nein'}); }
    if(von===3) track('wunsch',{rr_saison:saison, rr_wunsch:wunschText(), rr_duenger:duengerKey(), rr_hilfe:prefs.hilfe?'ja':'nein'});
    if(nach===4) trackErgebnis();
  }

  function props(weg){
    var z=C.zustaende[zustand-1];
    var w=[];
    if(prefs.schnell)  w.push('schnell');
    if(prefs.langzeit) w.push('langzeit');
    if(prefs.einfach)  w.push('einfach');
    if(prefs.hilfe)    w.push('hilfe');
    return {
      _quelle:      'rasenrechner',
      _rr_saison:   saison,
      _rr_weg:      weg,
      _rr_flaeche:  String(qm),
      _rr_zustand:  z ? z.kurz : 'unbekannt',
      _rr_wunsch:   w.length ? w.join('+') : 'keine'
    };
  }

  function build(){
    var z=C.zustaende[zustand-1]||C.zustaende[0];
    var duengerKey='fluessig';
    if(prefs.schnell&&prefs.langzeit)duengerKey='duo';
    else if(prefs.langzeit)duengerKey='kristall';
    var prod=C.produkte[duengerKey];

    var bedarfD=qm*(z.boost ? (C.boostFaktor||1) : 1);
    var kD=kombi(prod.sizes,bedarfD);
    var lueckenQm=Math.round(qm*z.anteil);
    var V={qm:qm,luecken:lueckenQm,menge:zusammen(kD),zustand:z.kurz};

    var g=[];
    g.push(T('menge_basis',V));
    if(z.boost) g.push(T('menge_boost',V));
    if(duengerKey==='fluessig') g.push(T(prefs.schnell?'fluessig_schnell':'fluessig_basis',V));
    if(duengerKey==='kristall') g.push(T('kristall_langzeit',V));
    if(duengerKey==='duo'){ g.push(T('duo_beides',V)); g.push(T('duo_ablauf',V)); }
    if(saison==='herbst') g.push(T('herbst_warum',V));
    if(prefs.einfach) g.push(T(duengerKey==='kristall'?'einfach_kristall':'einfach_fluessig',V));
    g.push(T('duenger_wasser',V));

    var items=[{
      p:prod, k:kD,
      need:bedarfHtml(prod,bedarfD,'für deine <strong>'+qm+' m²</strong>'),
      g:g
    }];

    if(lueckenQm>=3){
      var ziel='für rund <strong>'+lueckenQm+' m²</strong> Lücken';
      var ns=C.produkte.nachsaat, kn=kombi(ns.sizes,lueckenQm);
      var Vn={qm:qm,luecken:lueckenQm,menge:zusammen(kn),zustand:z.kurz};
      items.push({p:ns,k:kn,need:bedarfHtml(ns,lueckenQm,ziel),
        g:[T('nachsaat_flaeche',Vn),T('nachsaat_warum',Vn),T('nachsaat_wasser',Vn)]});
      var er=C.produkte.erde, ke=kombi(er.sizes,lueckenQm);
      var Ve={qm:qm,luecken:lueckenQm,menge:zusammen(ke),zustand:z.kurz};
      items.push({p:er,k:ke,need:bedarfHtml(er,lueckenQm,ziel),
        g:[T('erde_menge',Ve),T('erde_warum',Ve)]});
    }

    var optional=[];
    if(duengerKey==='kristall' && C.produkte.handstreuer){
      var hs=C.produkte.handstreuer;
      optional.push({p:hs,k:[{s:hs.sizes[0],qty:1}],need:'',
        g:[T('handstreuer_warum',V),T('handstreuer_hinweis',V)]});
    }
    return {items:items,optional:optional,lueckenQm:lueckenQm,z:z};
  }

  /* Empfehlungskarte im Look der Shop-Produktkacheln (V2.1).
     Spar-Badge = Vergleichspreis minus Verkaufspreis ueber die ganze Kombination.
     Der Erklaertext liegt in einer aufklappbaren Zeile, auf grossen Bildschirmen
     standardmaessig offen, auf dem Handy zu. Keine Sterne, Entscheidung Marco 25.08. */
  function karte(it,opt,idx){
    var why='';
    it.g.forEach(function(s){ if(s) why+='<li>'+s+'</li>'; });
    var erste=it.k.length?it.k[0].s.id:'';
    var p=kombiPreis(it.k), a=kombiAlt(it.k);
    var spar=(a-p>0.005)?(a-p):0;
    var offen=(window.innerWidth>=900)?' open':'';
    return '<div class="blrr-item2'+(opt?' blrr-item2--opt':'')+'">'+
      '<div class="blrr-t2media">'+
        (spar?'<span class="blrr-t2badge">Du sparst '+euro(spar)+'</span>':'')+
        (opt?'<span class="blrr-t2opt">Optional</span>':'')+
        '<img src="'+it.p.img+'" alt="'+esc(it.p.name)+'" loading="lazy">'+
      '</div>'+
      '<div class="blrr-t2body">'+
        '<div class="blrr-t2name">'+esc(it.p.name)+'</div>'+
        '<div class="blrr-t2price"><span class="blrr-t2cur">'+euro(p)+'</span>'+
          (spar?'<s class="blrr-t2alt">'+euro(a)+'</s>':'')+'</div>'+
        (it.need?'<div class="blrr-t2need">'+it.need+'</div>':'')+
        '<div class="blrr-t2size">'+esc(zusammen(it.k))+'</div>'+
        '<details class="blrr-t2why"'+offen+'><summary>Darum passt das zu deinem Rasen</summary>'+
          '<ul>'+why+'</ul></details>'+
        '<div class="blrr-t2actions">'+
          '<button type="button" class="blrr-itemAdd" data-i="'+idx+'">In den Warenkorb</button>'+
          '<a class="blrr-itemLink" data-i="'+idx+'" href="/products/'+encodeURIComponent(it.p.handle)+'?variant='+erste+'">Einzeln ansehen ›</a>'+
        '</div>'+
      '</div></div>';
  }

  function render(){
    /* Der Ergebnis-Schritt bekommt mehr Breite, damit auf dem Desktop
       drei Kacheln nebeneinander stehen statt zwei plus Umbruch. */
    root.classList.toggle('blrr--wide', step===4);
    $$('.blrr-step').forEach(function(el){el.hidden=(parseInt(el.getAttribute('data-step'),10)!==step);});
    $$('.blrr-dot').forEach(function(el,i){el.className='blrr-dot'+(i+1<=step?' is-on':'');});
    set('.blrr-qmOut','textContent',qm);
    if(step<4)return;
    var r=build(), total=0, totalAlt=0, html='';
    var alle=r.items.concat(r.optional);
    r.items.forEach(function(it,i){
      total+=kombiPreis(it.k);
      totalAlt+=kombiAlt(it.k);
      html+=karte(it,false,i);
    });
    r.optional.forEach(function(it,i){ html+=karte(it,true,r.items.length+i); });
    set('.blrr-items','innerHTML',html);
    if(totalAlt-total>0.005){
      set('.blrr-total','innerHTML','<s class="blrr-totalAlt">'+euro(totalAlt)+'</s>'+euro(total));
    }else{
      set('.blrr-total','textContent',euro(total));
    }
    set('.blrr-sum','textContent',qm+' m² · '+r.z.kurz+(r.lueckenQm>=3?' · ca. '+r.lueckenQm+' m² Lücken':''));
    var bonus=$('.blrr-bonus');
    if(bonus){
      var bt=bonus.querySelector('.blrr-bonusText');
      if(bt)bt.innerHTML=prefs.hilfe?C.bonus.gewaehlt:C.bonus.standard;
    }

    root._alle=alle;
    root._r=r; root._total=total; root._totalAlt=totalAlt;
    root._cart=[];
    r.items.forEach(function(it){ root._cart=root._cart.concat(cartLines(it.k)); });

    $$('.blrr-itemAdd').forEach(function(b){
      b.addEventListener('click',function(){
        var it=root._alle[parseInt(b.getAttribute('data-i'),10)];
        if(!it) return;
        var info=basis();
        info.rr_weg='einzeln';
        info.rr_produkte=produktText(it.k,it.p.name);
        info.rr_produkt=it.p.name;
        info.rr_anzahl=1;
        info.value=Math.round(kombiPreis(it.k)*100)/100;
        addToCart(cartLines(it.k),b,LADE,props('einzeln'),function(st){ info.rr_erfolg=st; track('add_to_cart',info); });
      });
    });
    $$('.blrr-itemLink').forEach(function(a){
      a.addEventListener('click',function(){
        var it=root._alle[parseInt(a.getAttribute('data-i'),10)];
        if(it) track('link_produkt',{rr_saison:saison, rr_produkt:it.p.name, rr_zustand:zustandKurz()});
      });
    });
  }

  var sl=$('.blrr-slider'), nu=$('.blrr-num');
  if(sl)sl.addEventListener('input',function(){eingabe.slider=true;qm=parseInt(this.value,10);if(nu)nu.value=qm;render();});
  /* Zahleneingabe: waehrend des Tippens nicht klemmen, sonst wird aus einer
     angefangenen 25 sofort eine 20. Geklemmt wird erst beim Verlassen des
     Feldes, und der geklemmte Wert wird ins Feld zurueckgeschrieben. */
  if(nu){
    nu.addEventListener('input',function(){
      eingabe.tippen=true;
      var v=parseInt(this.value,10);
      if(isNaN(v))return;
      if(v>=20&&v<=2000){ qm=v; if(sl)sl.value=Math.min(v,1200); render(); }
    });
    nu.addEventListener('change',function(){
      var v=parseInt(this.value,10);
      if(isNaN(v))v=200;
      if(v<20)v=20; if(v>2000)v=2000;
      qm=v; this.value=v;
      if(sl)sl.value=Math.min(v,1200);
      render();
    });
  }
  $$('.blrr-tile').forEach(function(t){t.addEventListener('click',function(){zustand=parseInt(t.getAttribute('data-z'),10);$$('.blrr-tile').forEach(function(x){x.classList.remove('is-sel');});t.classList.add('is-sel');var n=$('.blrr-next2');if(n)n.disabled=false;});});
  $$('.blrr-pref').forEach(function(p){p.addEventListener('click',function(){var k=p.getAttribute('data-p');prefs[k]=!prefs[k];p.classList.toggle('is-sel',prefs[k]);});});
  /* Scrollziel mit Abstand: .blrr hat scroll-margin-top in der CSS, damit die
     klebende Kopfzeile die Frage nicht verdeckt. */
  $$('[data-go]').forEach(function(b){b.addEventListener('click',function(){
    var von=step, nach=parseInt(b.getAttribute('data-go'),10);
    step=nach;render();root.scrollIntoView({behavior:'smooth',block:'start'});
    trackStep(von,nach);
  });});

  var add=$('.blrr-addAll');
  if(add)add.addEventListener('click',function(){
    var r=root._r, namen=[];
    if(r) r.items.forEach(function(it){ namen.push(produktText(it.k,it.p.name)); });
    var info=basis();
    info.rr_weg='alles';
    info.rr_produkte=namen.join('; ');
    info.rr_produkt=(r&&r.items[0]) ? r.items[0].p.name : '';
    info.rr_anzahl=r ? r.items.length : 0;
    info.value=Math.round((root._total||0)*100)/100;
    addToCart(root._cart,this,LADE,props('alles'),function(st){ info.rr_erfolg=st; track('add_to_cart',info); });
  });

  render();

  /* Start-Ereignis: Saison plus Einstieg (URL-Parameter und Referrer). */
  var ref='direkt';
  try{ if(document.referrer){ ref=document.referrer.replace(/^https?:\/\//,'').split('?')[0]; } }catch(e){}
  track('start',{rr_saison:saison, rr_einstieg:((location.search||'')+' '+ref).trim(), rr_geraet:(window.innerWidth<768?'mobil':'desktop')});
};
})();
